import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'goodmills',
} as IModuleProps;
